import React, { ReactNode, useContext } from 'react';
import CONSTITUENTS_QUERY from './queries/CONSTITUENTS_QUERY';
import Query from "../common/Query";
import { AppContext } from '../store';
import Loading from '../common/Loading';
import { Card, Table } from 'react-bootstrap';
import EventConstituent from './interfaces/EventConstituent';
import { useParams } from 'react-router-dom';
import { IObjectKeys } from './interfaces/ObjectKeys';
import { EventConsitutentDisplay, getKeyValue } from './displayValues';
import JoinCTA from '../common/JoinCTA';

const ConstituentList = () => {
    let { eventId }: { eventId?: string } = useParams();
    const { state } = useContext(AppContext);
    const isVolunteer = state.orgInfo?.volunteer_access;
    const isEC = state.orgInfo?.event_coordinator;
    const loading = state.orgInfo?.loading;
    const display = (constituent: IObjectKeys) => {
        const content = EventConsitutentDisplay;
        const body = Object.keys(content).filter((k: string) => !!getKeyValue(constituent, k)).map((k: string) => {
            return <tr key={k}><th>{getKeyValue(content, k) as ReactNode}</th><td>{getKeyValue(constituent, k) as ReactNode}</td></tr>
        });
        return body.length && <Table striped hover size="sm"><tbody>{body}</tbody></Table>
    }
    const displayConstituent = (constituent: EventConstituent) => {
        return <Card key={constituent.LookupId} className="mb-3">
            <Card.Header>{constituent.Name}</Card.Header>
            <Card.Body>{display(constituent)}</Card.Body>
        </Card>;
    };
    const displayConstituents = (events: EventConstituent[]) => {
        return events.map(e => displayConstituent(e));
    };
    if (isVolunteer || isEC) {
        return <Query variables={{ eventId }} query={CONSTITUENTS_QUERY}>{({ data: { constituents } }: { data: { constituents: EventConstituent[] } }) => {
            if (!constituents.length) {
                return <span>No attendees found for this event.</span>;
            } else {
                return displayConstituents(constituents);
            }
        }}
        </Query>;
    } else {
        if (loading) {
            return <Loading />
        } else {
            return <JoinCTA />
        }
    }
};

export default ConstituentList;